import React from 'react'
import commitment from "../assets/commitment.png"
import accessibility from "../assets/Accessibility.png"
import community from "../assets/communityService.png"
import "./styles.css"

const Card = (props) => {
    return (
        <div className='card'>
            <div className='img-heading'>
                <div className='card-img'><img style={{ maxHeight: "100%", maxWidth: "100%" }} src={props.img === "accessibility" ? accessibility : props.img === "commitment" ? commitment : community} alt="#" /></div>
                <h4>{props.heading}</h4>
            </div>
            <p>{props.content}</p>
        </div>
    )
}

export default Card
